var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPartners = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_partners24x24",
    transform: "translate(-2.004 -3)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46273",
    "data-name": "Path 46273",
    d: "M32.792,63.9a2.246,2.246,0,0,1,2.244-2.244H45.183l-3.1-4.616a1.357,1.357,0,0,0-1.881-.367l-9.55,6.429a1.357,1.357,0,0,0-.367,1.881L32.8,68.73V63.9Z",
    transform: "translate(-28.045 -53.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46274",
    "data-name": "Path 46274",
    d: "M121.981,220a1.351,1.351,0,0,0,1.351,1.351h11.713A1.351,1.351,0,0,0,136.4,220v-7.452a1.351,1.351,0,0,0-1.351-1.351H123.338a1.352,1.352,0,0,0-1.351,1.352V220Zm12.65-1.486h-4.865a.331.331,0,1,1,0-.655h4.865a.331.331,0,1,1,0,.655Zm.079-1.815h-4.062a.34.34,0,0,1,0-.678h4.063a.34.34,0,1,1,0,.678Zm-5.42-2.39h5.42a.34.34,0,0,1,0,.678h-5.42a.34.34,0,0,1,0-.678Zm-3.586-.332a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3Z",
    transform: "translate(-116.393 -202.355)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPartners);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_partners.962e73b2ce652294c94717d249324e1b.svg";